import { Route, Routes } from 'react-router-dom';

import { ROUTES } from '@/config/routes';
import AutomationLayout from '@/features/automation/layouts/AutomationLayout';
import Document from '@/features/automation/layouts/documents/document';
import Settings from '@/features/automation/layouts/documents/settings';
import Upload from '@/features/automation/layouts/documents/upload';

const { automation } = ROUTES.children;

export const AutomationRoutes = () => {
  return (
    <Routes>
      <Route element={<AutomationLayout />}>
        <Route path={automation.children?.home?.base} element={<Document />} />
        <Route path={automation.children?.documents?.base.replace('/*', '')}>
          <Route path={automation.children?.documents?.children?.upload?.base} element={<Upload />} />
          <Route path={automation.children?.documents?.children?.settings?.base} element={<Settings />} />
        </Route>
      </Route>
    </Routes>
  );
};
